import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-commercial-imputations-to-invoice',
  templateUrl: './dashboard-commercial-imputations-to-invoice.component.html',
  styleUrls: ['./dashboard-commercial-imputations-to-invoice.component.scss']
})
export class DashboardCommercialImputationsToInvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
